module.exports = __webpack_public_path__ + "img/zixun2.e9d64b5a.png";